import { Button } from '@seapoint/client/src/design-system/button/button';
import { EmployeeView, PayrollEvidenceLineItemView } from '@seapoint/client/src/types/entity-types';
import { cn } from '@seapoint/client/src/utils/cn';
import { LegalEntityCountry } from '@seapoint/server/enums';
import { EmployeeForm, EmployeeFormValues } from '../../add-employees-step/employee-drawer/employee-form';

type AddNewEmployeesProps = {
  evidenceItems: PayrollEvidenceLineItemView[];
  queueIndex: number;
  legalEntityCountry: LegalEntityCountry;
  isSubmitting: boolean;
  onSaveEmployee: (formData: EmployeeFormValues) => Promise<void>;
  onSkipEmployee: () => void;
};

export const AddNewEmployees = ({
  evidenceItems,
  queueIndex,
  legalEntityCountry,
  isSubmitting,
  onSaveEmployee,
  onSkipEmployee,
}: AddNewEmployeesProps) => {
  return (
    <>
      <h2 className="px-4 text-xl leading-[22px] font-medium -tracking-[0.02em]">
        Add employee information
        <span className="text-seapoint-gray-text ps-4 leading-[22px] -tracking-[0.02em]">
          {queueIndex + 1} of {evidenceItems.length}
        </span>
      </h2>
      {evidenceItems.map((record, idx) => {
        const destination: Pick<EmployeeView['destination'], 'iban' | 'accountNumber' | 'sortCode'> = {
          iban: record.iban,
          accountNumber: record.accountNumber,
          sortCode: record.sortCode,
        };
        const employee = {
          ...record,
          destination,
        } as EmployeeView;
        return (
          <div key={record.id} className={cn(idx === queueIndex ? null : 'hidden')}>
            <EmployeeForm
              showHeader={false}
              legalEntityCountry={legalEntityCountry}
              employee={employee}
              onSubmit={onSaveEmployee}
              showBottomSaveButton={true}
              isSubmitting={isSubmitting}
              onClose={() => {}}
            />
          </div>
        );
      })}
      <div className="-mt-8 px-4">
        <Button className="w-full" variant="secondary" onClick={onSkipEmployee} disabled={isSubmitting}>
          Skip this employee
        </Button>
      </div>
    </>
  );
};
